import moment from 'moment'

export default function formatPostDate(date) {
    if (!date) return null
    return moment(date, 'YYYY-MM-DD hh:mm:ss').format('MMM DD, YYYY - hh:mm')
}